<template>
    <b-card no-body :border-variant="borderVariant" :class="cardClass">
        <slot name="header">
            <div class="card-header">
                <b-col md="6" class="pl-0">
                    <b-card-title>
                        <slot name="header-label"/>
                    </b-card-title>
                </b-col>
                <b-col md="6" class="pr-0">
                    <div class="float-right">
                        <slot name="header-controls"/>
                    </div>
                </b-col>
            </div>
        </slot>

        <div v-if="items.length || emptyMode !== 'hidden'" :class="tableContainerClass" :style="tableContainerStyle">
            <table
                class="table b-table table-hover"
                :class="{'table-striped': striped, 'bordered': bordered}"
            >
                <thead>
                <tr>
                    <th v-for="column in columns" :class="column.thClass || ''" :key="column.key">
                        <slot :name="'header-cell-' + column.key" :column="column">
                            <div :class="column.class || ''" :title="column.title">{{ column.label }}</div>
                        </slot>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id || item.key || item.title" @click="onRowClick(item)">
                    <td v-for="column in columns" :key="column.key" :class="getColumnClass(column, item)">
                        <slot :name="'cell-' + column.key" :item="item" :column="column">
                            {{ renderValue(item, column) }}
                        </slot>
                    </td>
                </tr>
                </tbody>
                <tbody v-if="!items.length && emptyMode === 'message'">
                <tr class="bg-white">
                    <td :colspan="columns.length">
                        <b-alert
                            class="m-2"
                            variant="secondary"
                            show
                        >
                            <div class="alert-body">
                                <slot name="no-records">
                                    {{ $t('Component(Text):nothing-found') }}
                                </slot>
                            </div>
                        </b-alert>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else />
    </b-card>
</template>

<script>
import { BCard, BCol, BCardTitle, BAlert } from 'bootstrap-vue'

export default {
    components: {
        BCard, BCol, BCardTitle, BAlert
    },
    props: {
        borderVariant: {
            default: ''
        },
        cardClass: {
            default: ''
        },
        tdClassProvider: {
            default: null
        },
        tableContainerClass: {
            default: 'table-responsive hamlet-table',
        },
        tableContainerStyle: {
            default: ''
        },
        striped: {
            type: Boolean,
            default: true,
        },
        bordered: {
            type: Boolean,
            default: true,
        },
        columns: {
            type: Array,
            default() {
                return [];
            }
        },
        items: {
            type: Array,
            default() {
                return [];
            }
        },
        emptyMode: {
            type: String,
            default: 'message',
            validator(value) {
                return ['message', 'blank', 'hidden'].includes(value);
            }
        }
    },
    methods: {
        renderValue(item, column) {
            if (item.hasOwnProperty(column.key)) {
                if (item[column.key] instanceof Object && item[column.key].hasOwnProperty('title')) {
                    return item[column.key].title;
                }

                return item[column.key];
            }

            return '';
        },
        getColumnClass(column, item) {
            if (this.tdClassProvider) {
                return (this.tdClassProvider)(column, item);
            }
            return column.tdClass;
        },
        onRowClick(item) {
            this.$emit('onRowClick', item);
        },
    },
}
</script>

<style lang="scss">
.hamlet-table {
    table {
        td,th {
            white-space: nowrap;
        }
    }
}
</style>
